import React from "react";
import { NavLink } from "react-router-dom";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { editDefaultPlan } from "store/actions";
import { displayBackupSchedule } from "utils";

function EditDefaultPlan(props) {
  return (
    <>
      <div
        className={
          "id-card-blk id-card-hgt id-card-dftbckp" +
          (props.backupPlanList?.[1]?.status ===
          props.enums?.BackupPlanStatus?.DISABLED
            ? " id-disabled-section"
            : "")
        }
      >
        <div className="id-card-100">
          <h2>Default Backup Plan:</h2>
          <p>
            Once the backup agent is installed on a device, the default backup
            plan will be applied to it.
          </p>
          <ul>
            <li>
              <h5>
                Backup schedule
                <i className="id-information-fcs id-information-rnd-fcs">
                  <div className="id-tooltip id-tooltip-rightcenter">
                    <p className="id-tooltip-content">
                      Backup will be initiated automatically at the scheduled
                      time
                    </p>
                  </div>
                </i>
              </h5>
              <p>
                {displayBackupSchedule(
                  props.backupPlanList?.[1]?.scheduleInfo,
                  props.enums
                )}
              </p>
            </li>
          </ul>

          <NavLink to={"/mirror/backupPlan"}>
            <button
              className={
                "id-btn id-primary-btn" +
                (props.backupPlanList?.[1]?.scheduleInfo ? "" : " btn_disable")
              }
              onClick={e => props.editDefaultPlan(true)}
            >
              Edit default backup plan
            </button>
          </NavLink>
        </div>
        {props.backupPlanList?.[1]?.status ===
          props.enums?.BackupPlanStatus?.DISABLED && (
          <div class="disable-note">
            <p>
              <b>Note:</b> Default backup plan is currently disabled. To enable
              it, go to the <b>Backup Plan</b> section.
            </p>
          </div>
        )}
      </div>
    </>
  );
}

function mapStateToProps(state) {
  return {
    backupPlanList: state.backupPlan.backupPlans.data,
    enums: state.common.enums
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      editDefaultPlan
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(EditDefaultPlan);
